import React, { FC, MouseEvent } from 'react';
import withStyles from 'src/common/withStyles';

import { decorateComponent, getClassNameFor } from '../../helpers';
import { validateRedirect } from '../../utils/routing';

import s from './CloseButton.module.scss';

/**
 * Requires `backUrl` or `onClick`.
 * Requires `className` or `classNameModifier`.
 */
type CloseButtonProps =
  | {
    backUrl: string;
    className?: never;
    classNameModifier?: string;
    onClick?: never;
  }
  | {
    backUrl?: never;
    className: string;
    classNameModifier?: never;
    onClick: (() => void) | ((e: MouseEvent<HTMLButtonElement>) => void);
  }
  | {
    backUrl: string;
    className: string;
    classNameModifier?: never;
    onClick?: never;
  }
  | {
    backUrl?: never;
    className?: never;
    classNameModifier?: string;
    onClick: (() => void) | ((e: MouseEvent<HTMLButtonElement>) => void);
  };

const CloseButton: FC<CloseButtonProps> = ({
  backUrl,
  className,
  classNameModifier,
  onClick,
}) => (
  <div className={className || getClassNameFor(s, 'root', classNameModifier)}>
    {backUrl && (
      <a
        href={validateRedirect(backUrl)}
        aria-label="Close"
        className={getClassNameFor(s, 'link', classNameModifier)}
      >
        <svg className={getClassNameFor(s, 'icon', classNameModifier)}>
          <use xlinkHref="#icon-close" />
        </svg>
      </a>
    )}
    {onClick && (
      <button
        type="button"
        onClick={onClick}
        aria-label="Close"
        className={getClassNameFor(s, 'button', classNameModifier)}
      >
        <svg className={getClassNameFor(s, 'icon', classNameModifier)}>
          <use xlinkHref="#icon-close" />
        </svg>
      </button>
    )}
  </div>
);

const decorators = [
  withStyles(s),
];

export default decorateComponent(CloseButton, decorators);
